import { nextTick, ref } from 'vue';

/**
 * The text a live region reads out, and the one way to change it.
 *
 * The value is cleared and re-set rather than assigned, so a second identical outcome is still a
 * text change and so is still announced: a retry that fails the same way must not be
 * indistinguishable from a press that did nothing.
 *
 * That re-set happens a tick later, which is what makes ORDER a question: two announcements in
 * quick succession would otherwise land in the order their ticks resolve, not the order they were
 * asked for, and the older text would be the one left on the region. A charge refused the instant
 * it is sent leaves "Charging your card" standing after the decline has already been read. The
 * token drops any write a newer call has superseded, clear included.
 *
 * Bind `announcement` to an element carrying role="status".
 */
export function useLiveAnnouncer() {
    const announcement = ref('');
    let latest = 0;

    const announce = async (message: string) => {
        const token = ++latest;
        announcement.value = '';
        if (!message) return;

        await nextTick();
        if (token === latest) announcement.value = message;
    };

    return { announcement, announce };
}
